import openWindow from '@/script/openWindow.mjs'

export const canPreviewUv = (map, uv) => {
    // const {demoType, pkid: uvId, uiId} = uv.data

    // if ('DEMO' === demoType && !uvId) {
    //     return false
    // }

    // if ('IMG' === demoType) {
    //     if (! uiId) {
    //         return false
    //     }

        // return [...map.children(uv)].some(
        //     n => n.data.fileId
        // )
    // }

    return true
}

export const previewUv = (map, uv, target) => {
    const { pkid: sfId } = uv.data


    openWindow('/FormilyUcPreview', { sfId }, target)
}
